import { createSlice } from "@reduxjs/toolkit";
import { requestPending } from "../../../constants/constants";

const namespace = 'removeProjectDialog'
const initialState = {
    isOpen:false,
    id:0,
    status: requestPending
}

export const removeProjectDialog = createSlice({
    name : namespace,
    initialState : initialState,
    reducers:{
        openRemoveDialog: (state,action) => {
            state.id = action.payload;
            state.isOpen = true;
        },
        closeRemoveDialog:(state) => {
            state.isOpen = false;
        },
    },
})

export const removeProjectDialogReducer = removeProjectDialog.reducer;
export const { openRemoveDialog, closeRemoveDialog } = removeProjectDialog.actions;